import React from 'react';

import { vw } from 'utils/index';

import { useResponsive } from './responsive';

interface IUseGetVirtualListProps<T> {
  list: Array<T>;
}

export const useGetVirtualListProps = <T>({ list }: IUseGetVirtualListProps<T>) => {
  const [isMobile] = useResponsive('MOBILE');
  const columnsAmount: number = isMobile ? 4 : 1;

  const rowsAmount = React.useMemo(() => Math.ceil(list.length / columnsAmount), [list, columnsAmount]);

  const getRowHeight = React.useCallback(
    (containerHeight: number): number => {
      if (isMobile) {
        return containerHeight / 2.4;
      }

      const height = vw((70 / 1280) * 100);

      return height;
    },
    [isMobile],
  );

  const getColumnWidth = React.useCallback(
    (containerWidth: number): number => {
      return (containerWidth / columnsAmount) * 0.97;
    },
    [columnsAmount],
  );

  const getItemIndex = React.useCallback(
    (rowIndex: number, columnIndex: number): number => {
      let index = 0;

      if (!isMobile) {
        index = rowIndex;
      } else {
        index = rowIndex * 4 + columnIndex;
      }

      return index;
    },
    [isMobile],
  );

  return { rowsAmount, columnsAmount, getRowHeight, getColumnWidth, getItemIndex };
};
